import { useNavigate } from 'react-router-dom';
import { 
  Briefcase, Users, BookOpen, Shield, Mail, 
  Linkedin, Twitter, Facebook, Heart
} from 'lucide-react';

export default function Footer() {
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="container mx-auto px-6 py-12">
        <div className="grid md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="space-y-4">
            <div className="flex items-center gap-2">
              <img src="/logo.svg" alt="The Interview" className="w-8 h-8 invert" />
              <span className="text-xl font-heading font-bold text-white">The Interview</span>
            </div>
            <p className="text-sm text-gray-400">
              Skip the application. Start the interview. Connect directly with hiring companies through video interviews.
            </p>
            <div className="flex gap-4">
              <a href="#" className="hover:text-white transition-colors">
                <Linkedin size={20} />
              </a>
              <a href="#" className="hover:text-white transition-colors">
                <Twitter size={20} />
              </a>
              <a href="#" className="hover:text-white transition-colors">
                <Facebook size={20} />
              </a>
            </div>
          </div>

          {/* For Candidates */}
          <div>
            <h3 className="text-white font-semibold mb-4">For Candidates</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <button onClick={() => navigate('/marketplace')} className="hover:text-white transition-colors">
                  Marketplace
                </button>
              </li>
              <li>
                <button onClick={() => navigate('/resume-builder')} className="hover:text-white transition-colors">
                  Resume Builder
                </button>
              </li>
              <li>
                <button onClick={() => navigate('/interview-prep')} className="hover:text-white transition-colors">
                  Interview Prep
                </button>
              </li>
              <li>
                <button onClick={() => navigate('/mentorship')} className="hover:text-white transition-colors">
                  Find a Mentor
                </button>
              </li>
              <li>
                <button onClick={() => navigate('/background-check')} className="hover:text-white transition-colors">
                  Background Check
                </button>
              </li>
            </ul>
          </div>

          {/* For Companies */}
          <div>
            <h3 className="text-white font-semibold mb-4">For Companies</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <button onClick={() => navigate('/candidate/dashboard')} className="hover:text-white transition-colors">
                  Browse Jobs
                </button>
              </li>
              <li>
                <button onClick={() => navigate('/company/dashboard')} className="hover:text-white transition-colors">
                  Post a Job
                </button>
              </li>
              <li>
                <button onClick={() => navigate('/browse-candidates')} className="hover:text-white transition-colors">
                  Browse Candidates
                </button>
              </li>
              <li>
                <button onClick={() => navigate('/marketplace')} className="hover:text-white transition-colors">
                  Pricing
                </button>
              </li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h3 className="text-white font-semibold mb-4">Resources</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <button onClick={() => navigate('/become-mentor')} className="hover:text-white transition-colors flex items-center gap-2">
                  <Heart size={14} className="text-pink-400" />
                  Become a Mentor
                </button>
              </li>
              <li>
                <button onClick={() => navigate('/community')} className="hover:text-white transition-colors">
                  Community
                </button>
              </li>
              <li>
                <button onClick={() => navigate('/privacy')} className="hover:text-white transition-colors">
                  Privacy Policy
                </button>
              </li>
              <li>
                <button onClick={() => navigate('/background-check-policy')} className="hover:text-white transition-colors">
                  Background Check Policy
                </button>
              </li>
              <li>
                <button onClick={() => navigate('/terms')} className="hover:text-white transition-colors">
                  Terms of Service
                </button>
              </li>
              <li>
                <a href="mailto:support@theinterviewpros.com" className="hover:text-white transition-colors flex items-center gap-2">
                  <Mail size={14} />
                  Contact Us
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-gray-500">
            © {currentYear} The Interview. All rights reserved.
          </p>
          <div className="flex gap-6 text-sm text-gray-500">
            <button onClick={() => navigate('/privacy')} className="hover:text-white transition-colors">
              Privacy
            </button>
            <button onClick={() => navigate('/terms')} className="hover:text-white transition-colors">
              Terms
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}
